var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAplicaIaIcone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "neonbar",
    x1: 95,
    y1: 164,
    x2: 145,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A78BFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#101626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0B0F1A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    rx: 52,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 78 200 L 117 106",
    stroke: "#E8ECF4",
    strokeWidth: 14,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 123 106 L 162 200",
    stroke: "#E8ECF4",
    strokeWidth: 14,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 164,
    x2: 145,
    y2: 164,
    stroke: "url(#neonbar)",
    strokeWidth: 14,
    strokeLinecap: "round",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 82,
    r: 11,
    fill: "#22D3EE",
    filter: "url(#glow)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAplicaIaIcone);
export default __webpack_public_path__ + "static/media/aplica-ia-icone.899d3f5645635d9d33e7d69796f73ae5.svg";
export { ForwardRef as ReactComponent };